import { db } from "helpers/firebase/firebaseConfig";
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import Cookies from "js-cookie";
import { actionTypes } from "./actionTypes";
import { setProviderErpInvoices, setProviderErpInvoicesError, setProviderErpInvoicesLoading } from "./actions";
import { call, put, takeEvery } from 'redux-saga/effects';

async function fetchProviderErpInvoicesFromFirebase() {
  try {
    const userId = Cookies.get("usersessionId", {
      secure: true,
      sameSite: "strict",
      path: "/",
    });

    if (!userId) throw new Error("User ID not found");

    // Fetch ERP invoices for this service provider
    // These are commission invoices issued to the service provider
    const invoicesQuery = query(
      collection(db, "providers_transactions_history"),
      where("service_provider_id", "==", userId),
      orderBy("transaction_date", "desc")
    );
    
    const invoicesSnapshot = await getDocs(invoicesQuery);
    
    const invoices = [];
    invoicesSnapshot.forEach(doc => {
      invoices.push({
        id: doc.id,
        ...doc.data()
      });
    });

    return invoices;
  } catch (error) {
    console.error("Error fetching provider ERP invoices:", error);
    throw error;
  }
}

function* fetchProviderErpInvoicesSaga() {
  try {
    yield put(setProviderErpInvoicesLoading(true));
    const invoices = yield call(fetchProviderErpInvoicesFromFirebase);
    yield put(setProviderErpInvoices(invoices));
  } catch (error) {
    console.error("Saga error:", error);
    yield put(setProviderErpInvoicesError(error.message));
  }
}

export default function* providerErpInvoicesSaga() {
  yield takeEvery(actionTypes.FETCH_PROVIDER_ERP_INVOICES, fetchProviderErpInvoicesSaga);
}
